export const PAGE = {
	VIEW_EVENT: 0,
	ADD_ATTENDANCE: 1,
	ADD_STUDENT_REPORT: 2,
};

export const addAttendanceInitialFormState = {
	studentSignature: "",
	teacherSignature: "",
};

export const initialEventProp = {
	id: "",
};

export const transformData = (data) => {
	return {
		...data,
		studentIds: data?.students?.map((student) => student?.studentDetail?.id),
		isCustomLesson: data?.lesson?.isCustomLesson || false,
		...(data?.lesson?.isCustomLesson && {
			customLessonName: data?.lesson.name,
		}),
		observers: data?.observers?.map(
			(observer) => observer.observerDetail || observer,
		),
		rawObservers: data?.observers,
	};
};
